export const CART_EVENTS = {
  OPEN: 'cart:open',
  UPDATE: 'cart:update'
};
